<template>
  <v-card-text>
    <v-row>

      <v-col cols="12">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">
              List ALL state(s) in which employees are working or residing
            </v-list-item-title>
            <v-list-item-subtitle>{{ statez }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>

      <v-col
        cols="12"
        v-for="(item, index) in prospectPacket.officeLocations"
        :key="index"
      >
        <v-card flat style="background-color: transparent !important">
          <v-card-title class="text-body-1 font-weight-medium">Location {{ index + 1 }}</v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <v-row>

              <v-col cols="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Street Address</v-list-item-title>
                    <v-list-item-subtitle>{{ item.address }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">City</v-list-item-title>
                    <v-list-item-subtitle>{{ item.city }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col cols="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">State</v-list-item-title>
                    <v-list-item-subtitle>{{ item.state }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
               </v-col>

              <v-col cols="6">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">Postal Code</v-list-item-title>
                    <v-list-item-subtitle>{{ item.zip }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
  </v-card-text>
</template>

<script>
export default {
  name: 'OfficeLocations',
  data: () => ({
    temp: null,
  }),
  computed: {
    prospectPacket() {
      return this.$store.state.prospectPacket;
    },
    statez() {
      return this.prospectPacket.companyInfo.employeeWorkStates;
    },
    employeeWorkStates() {
      if (this.statez === null) {
        return [];
      }
      return this.statez.split(',').map((value) => value.trim());
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
